import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>
      <p className="last-updated">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <section className="terms-section">
        <h2>1. Introduction</h2>
        <p>
          Welcome to Internet Made Media FZCO ("Company", "we", "our", "us"). These Terms and Conditions govern your use of our website and services related to expat relocation, UAE company setup, Mexico residency, citizenship by investment, and related consulting services.
        </p>
        <p>
          By accessing our website or using our services, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, please do not use our services.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. Company Information</h2>
        <p>
          <strong>Internet Made Media FZCO</strong><br />
          24805 - 001, IFZA Business Park<br />
          Dubai Digital Park<br />
          Dubai, United Arab Emirates
        </p>
      </section>

      <section className="terms-section">
        <h2>3. Services</h2>
        <p>
          We provide information and facilitate connections to certified partners for:
        </p>
        <ul>
          <li>UAE company setup and relocation services</li>
          <li>Mexico residency programs</li>
          <li>Citizenship by investment programs</li>
          <li>International tax optimization consulting</li>
          <li>Real estate investment guidance</li>
          <li>Personal consulting services</li>
        </ul>
        <p>
          All services are provided through our vetted partners. We act as an intermediary and information provider.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. Service Fees and Payments</h2>
        <p>
          Service fees vary depending on the specific service requested. All fees will be clearly communicated before any service agreement is finalized. Payment terms will be specified in individual service agreements.
        </p>
        <p>
          Consultation fees are $400 per hour unless otherwise specified. Government fees, translation costs, and third-party expenses are separate from our service fees.
        </p>
      </section>

      <section className="terms-section">
        <h2>5. No Guarantees</h2>
        <p>
          While we work with experienced and certified partners, we cannot guarantee specific outcomes for residency applications, citizenship applications, or any government-related processes. Success depends on individual circumstances, government policies, and proper documentation.
        </p>
        <p>
          Immigration laws and regulations change frequently. Information provided on our website is for general guidance only and should not be considered legal advice.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. Client Responsibilities</h2>
        <p>
          Clients are responsible for:
        </p>
        <ul>
          <li>Providing accurate and complete information</li>
          <li>Submitting required documentation in a timely manner</li>
          <li>Meeting financial requirements for chosen programs</li>
          <li>Complying with all applicable laws and regulations</li>
          <li>Paying all fees as agreed</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>7. Confidentiality</h2>
        <p>
          We respect your privacy and will handle all personal information in accordance with applicable data protection laws. Client information will only be shared with our certified partners as necessary to provide requested services.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. Limitation of Liability</h2>
        <p>
          Internet Made Media FZCO and its partners shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services or any delays, errors, or omissions in the provision of services.
        </p>
        <p>
          Our liability is limited to the amount of fees paid for the specific service in question.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. Refund Policy</h2>
        <p>
          Refund policies vary by service and will be specified in individual service agreements. Generally, consultation fees are non-refundable once the consultation has been conducted. Service fees may be partially refundable if services have not yet been rendered.
        </p>
      </section>

      <section className="terms-section">
        <h2>10. Intellectual Property</h2>
        <p>
          All content on this website, including text, graphics, logos, and software, is the property of Internet Made Media FZCO or its content suppliers and is protected by international copyright laws.
        </p>
      </section>

      <section className="terms-section">
        <h2>11. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not responsible for the content, privacy policies, or practices of these external sites.
        </p>
      </section>

      <section className="terms-section">
        <h2>12. Modifications</h2>
        <p>
          We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting to the website. Continued use of our services after changes constitutes acceptance of the modified terms.
        </p>
      </section>

      <section className="terms-section">
        <h2>13. Governing Law</h2>
        <p>
          These Terms and Conditions shall be governed by and construed in accordance with the laws of the United Arab Emirates. Any disputes shall be subject to the exclusive jurisdiction of the courts of Dubai, UAE.
        </p>
      </section>

      <section className="terms-section">
        <h2>14. Contact Information</h2>
        <p>
          For questions about these Terms and Conditions, please contact us through the consultation form on our website.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;

